
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityFeedIdea"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Idea"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"anonymous"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"awardWinningContestIdeas"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"award"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contestId"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"elevatorPitch"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"weeklyTopIdea"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"closedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expectedReturn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalReturn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"returnVsBenchmark"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"attachmentExtensions"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"posted"},"name":{"kind":"Name","value":"openedAt"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"updated"},"name":{"kind":"Name","value":"lastUpdatedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"commentsCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phraseCount"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"canCurrentUserViewIdeaFilterDetails"},"name":{"kind":"Name","value":"canCurrentUserAccess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"resource"},"value":{"kind":"StringValue","value":"idea_filter_details","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"permission"},"value":{"kind":"StringValue","value":"view","block":false}}],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"positions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"direction"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"asset"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"primarySymbol"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assetClassName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fundamental"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"marketCap"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"expectedPerformanceRating"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"averageRating"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userRatingCount"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"isNonBuyside"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"authorName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tagList"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityFeedUser"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResearchItemUser"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isRanked"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"username"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"commentsCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"youtubeIds"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":917}};
    doc.loc.source = {"body":"#import './ActivityFeedUser.graphql'\n#import './ResearchItemUser.graphql'\n\nfragment ActivityFeedIdea on Idea {\n  id\n  anonymous\n  awardWinningContestIdeas {\n    id\n    award\n    contestId\n  }\n  elevatorPitch\n  weeklyTopIdea\n  closedAt\n  expectedReturn\n  totalReturn\n  returnVsBenchmark\n  attachmentExtensions\n  posted: openedAt\n  updated: lastUpdatedAt\n  commentsCount\n  phraseCount\n  canCurrentUserViewIdeaFilterDetails: canCurrentUserAccess(\n    resource: \"idea_filter_details\"\n    permission: \"view\"\n  )\n  positions {\n    id\n    direction\n    asset {\n      id\n      primarySymbol\n      assetClassName\n      name\n      fundamental {\n        id\n        marketCap\n      }\n    }\n  }\n  expectedPerformanceRating {\n    id\n    averageRating\n    userRatingCount\n  }\n  isNonBuyside\n  authorName\n  tagList\n  user {\n    ...ActivityFeedUser\n    ...ResearchItemUser\n    isRanked\n    username\n  }\n  commentsCount\n  youtubeIds\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('./ActivityFeedUser.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./ResearchItemUser.graphql').definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["ActivityFeedIdea"] = oneQuery(doc, "ActivityFeedIdea");
        
